// Step-based validation schemas imported from @core/domain
import {
  SchrittPayloadWarteAufReaktivierungInitial,
  SchrittPayloadTransformationInitial,
  SchrittPayloadFachlicheValidierungInitial,
  SchrittPayloadWeiterleitungAnDokumentenDienstleisterInitial,
  SchrittPayloadEmailVersandInitial,
  SchrittPayloadAntwortVonDokumentDienstleisterInitial,
  SchrittPayloadArchivierungInitial,
  SchrittPayloadBestaetigeVerarbeitungBeiDokumentDienstleisterInitial,
  VorgangProzessSchritt,
} from '@core/domain';

// Use the actual schemas from @core/domain
export const SchrittPayloadWarteAufReaktivierungInitialSchema =
  SchrittPayloadWarteAufReaktivierungInitial;
export const SchrittPayloadTransformationInitialSchema =
  SchrittPayloadTransformationInitial;
export const SchrittPayloadFachlicheValidierungInitialSchema =
  SchrittPayloadFachlicheValidierungInitial;
export const SchrittPayloadWeiterleitungAnDokumentenDienstleisterInitialSchema =
  SchrittPayloadWeiterleitungAnDokumentenDienstleisterInitial;
export const SchrittPayloadEmailVersandInitialSchema =
  SchrittPayloadEmailVersandInitial;
export const SchrittPayloadAntwortVonDokumentDienstleisterInitialSchema =
  SchrittPayloadAntwortVonDokumentDienstleisterInitial;

// Mapping from step type to schema
export const STEP_VALIDATION_SCHEMAS = {
  [VorgangProzessSchritt.WARTE_AUF_REAKTIVIERUNG_DES_DOKUMENTTYPS]:
    SchrittPayloadWarteAufReaktivierungInitialSchema,
  [VorgangProzessSchritt.TRANSFORMATION]:
    SchrittPayloadTransformationInitialSchema,
  [VorgangProzessSchritt.FACHLICHE_VALIDIERUNG]:
    SchrittPayloadFachlicheValidierungInitialSchema,
  [VorgangProzessSchritt.WEITERLEITUNG_AN_DOKUMENTDIENSTLEISTER]:
    SchrittPayloadWeiterleitungAnDokumentenDienstleisterInitialSchema,
  [VorgangProzessSchritt.ANTWORT_VON_DOKUMENTDIENSTLEISTER]:
    SchrittPayloadAntwortVonDokumentDienstleisterInitialSchema,
  [VorgangProzessSchritt.ARCHIVIERUNG]: SchrittPayloadArchivierungInitial,
  [VorgangProzessSchritt.EMAIL_VERSAND]:
    SchrittPayloadEmailVersandInitialSchema,
  [VorgangProzessSchritt.BESTAETIGE_VERARBEITUNG_BEI_DOKUMENTDIENSTLEISTER]:
    SchrittPayloadBestaetigeVerarbeitungBeiDokumentDienstleisterInitial,
} as const;

// Re-export types and enums from @core/domain
export type {
  SchrittPayloadWarteAufReaktivierungInitial,
  SchrittPayloadTransformationInitial,
  SchrittPayloadFachlicheValidierungInitial,
  SchrittPayloadWeiterleitungAnDokumentenDienstleisterInitial,
  SchrittPayloadEmailVersandInitial,
  SchrittPayloadAntwortVonDokumentDienstleisterInitial,
  SchrittPayloadArchivierungInitial,
  SchrittPayloadBestaetigeVerarbeitungBeiDokumentDienstleisterInitial,
} from '@core/domain';

export { VorgangProzessSchritt } from '@core/domain';
